"use client";
import { Slider, styled } from "@mui/material";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";
import { buildSearchUrl, Props as PageProps } from "../../util";
import { useRouter } from "next/navigation";
import { formatInteger } from "@/utils/priceUtils";
import { sendClickTrack } from "@/tracks/25157";
import { sendClickTrack as sendClickTrackForAddon } from "@/tracks/25282";
import { sendClickTrack as sendClickTrackForPromotion } from "@/tracks/25348";
import { useTranslation } from "@/i18n/client";

const PSlider = styled(Slider)({
  color: "var(--sys-Text-Primary)", // 主色调
  "& .MuiSlider-thumb": {
    backgroundColor: "#ffffff", // 滑块的颜色
    border: "3px solid var(--sys-Text-Primary)",
    "&:hover": {
      boxShadow: "0 0 0 8px rgba(26, 26, 26, 0.16)",
    },
    "&.Mui-focusVisible": {  // 选中状态
      boxShadow: "0 0 0 8px rgba(26, 26, 26, 0.16)",
    }
  },
  "& .MuiSlider-track": {
    backgroundColor: "var(--sys-Text-Primary)", // 已拖动部分轨道颜色
    border: "0px",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#E1E3E6",
  },
});

interface PriceSliderProps {
  max: number;
  min: number;
  // priceLeft: number;
  // priceRight: number;
  searchParams: PageProps["searchParams"];
  basePath: string;
  commonTracks: { keyWord: string; categoryId: string; logid: string; pvid: string; mtest: string; request_id: string; channelName: string; };
  isAddon: boolean;
  localInfo: any;
}

export default function PriceSlider(props: PriceSliderProps) {
  const {t} = useTranslation();
  const router = useRouter();
  let { max, min, searchParams, basePath, isAddon, commonTracks, localInfo={} } = props;
  const { filterByPrice } = searchParams;

  const priceLeft = filterByPrice ? Number(filterByPrice.split("M")[1]) : min;
  const priceRight = filterByPrice ? Number(filterByPrice.split("L")[1].split("M")[0]) : max;
  max = Math.max(max, priceRight);
  min = Math.min(min, priceLeft);

  const [rangeLeft, setRangeLeft] = useState(priceLeft);
  const [rangeRight, setRangeRight] = useState(priceRight);

  useEffect(() => {
    setRangeLeft(priceLeft);
    setRangeRight(priceRight);
  }, [priceLeft, priceRight]);

  return (
    <>
      <div className={styles.sliderBox}>
        <span className={`${styles.currPrice} ${styles.left}`}>{localInfo?.currencySymbol}{formatInteger(rangeLeft)}</span>
        <span className={`${styles.currPrice} ${styles.right}`}>{localInfo?.currencySymbol}{formatInteger(rangeRight)}</span>
        <PSlider
          min={min}
          max={max}
          valueLabelDisplay="off"
          aria-label="price filter"
          value={[rangeLeft, rangeRight]}
          onChange={(event, v) => {
            const [l, r] = v as number[];
            setRangeLeft(l);
            setRangeRight(r);
            !isAddon ? sendClickTrack.Search_ProductList_Option_Price_Confirm() : sendClickTrackForAddon.FreeShippingAddOn_FilterLayer_Price_Click({ ...commonTracks, "pos": 0, "filter_name": "price" }
            );
          }}
        />
      </div>
      <span
        className={styles.btn}
        onClick={() => {
          sendClickTrackForPromotion.Promotion_FilterLayer_ConfirmBtn_Click({price: `${rangeLeft}-${rangeRight}`})
          const searchUrl = buildSearchUrl(searchParams, { filterByPrice: `L${rangeRight}M${rangeLeft}`, page: "1" }, { basePath });
          router.push(searchUrl);
        }}
      >
        {t("s.go")}
      </span>
    </>
  );
}
